export const lang = {
    "item1":"关于",
    "item2":"产品与服务",
    "item3":"联系我们",
    "intro1":"NDC（New Distribution Capability 新分销能力）是国际航空运输协会（IATA）的一项新分销标准，航司可通过NDC标准向代理商提供丰富的产品信息、个性化的产品、完善的服务功能。",
    "intro2":"SmartNDC是一个航司NDC服务的聚合器，帮助代理商对接航司NDC，提供简单丰富的JSON API接口，在线预订工具，手机预订页面等。可以满足代理商的客户管理，渠道分销的需求。支持基于NDC的选座、行李、贵宾室、往返、多程等。",    
    "title1":"在线预订工具",
    "subtitle1":"航司NDC产品的在线预订与管理，满足自订与分销的需求。",
    "title2":"手机预订页面",
    "subtitle2":"自适应的手机预订页面，方便手机访问或嵌入手机应用。",    
    "title3":"简洁的JSON API",
    "subtitle3":"满足基本的预定、出票需求，减少开发与集成的复杂度。",
    "title4":"详细的JSON API",
    "subtitle4":"支持航司NDC的全部功能，方便定制开发各种应用。",       
    "title5":"可选择云服务",
    "subtitle5":"灵活快速使用，减少部署和运营成本。",
    "title6":"可本地部署",
    "subtitle6":"保障私密数据的安全性，可定制开发。",    
    "title7":"功能升级",
    "subtitle7":"持续免费的产品功能升级，以适应NDC技术发展。",
    "title8":"技术服务",
    "subtitle8":"7*24小时技术服务，保障运营不间断。",        
    "copyright":"北京点动创想科技有限公司", 
    "c_name":"名称*", 
    "c_email":"邮箱*", 
    "c_phone":"电话*", 
    "c_message":"咨询信息*", 
    "c_send":"发送", 
}